import { StoreType } from 'pages/Store/Store.types';
import { DefaultAddress, IAddress } from '../../../contexts/CartContext/CartContext.types';
import { IShipping } from '../../../types/Shipping';

export interface IStoreLocation {
    name: string;
    storeType: StoreType;
    idiName: string;
    address: IAddress;
    distanceInMiles: number;
    distanceInKm: number;
    storePageUrl: string;
    isVisible: boolean;
}

export const DefaultStoreLocation = (): IStoreLocation => {
    return {
        address: DefaultAddress(),
        distanceInKm: 0,
        distanceInMiles: 0,
        name: '',
        idiName: '',
        storePageUrl: '',
        storeType: StoreType.Store,
        isVisible: true
    };
};

export interface IStoreLocatorResultRadioGroupProps {
    results: IStoreLocation[];
    groupName: string;
}

export interface IStoreLocatorResultCardProps {
    result: IStoreLocation;
    groupName: string;
    selected: boolean;
    onChange: (value: string) => void;
}

export interface IStoreLocatorProps {
    searchType: 'store' | 'post-office';
    buttonText: string;
    shippingCost: IShipping;
    overnightShipping: boolean;
    setOvernightShipping: (value: boolean) => void;
}
